import React from "react";
import { Link, withRouter } from "react-router-dom";
import { createUseStyles } from "react-jss";
import classNames from "classnames";
import Container from "reactstrap/lib/Container";
import Row from "reactstrap/lib/Row";
import { useWithDefaultParams } from "Services/useWithDefaultParams";
import { generateUrl } from "Services/withDefaultParams";
import configRouters from "Configs/routes";
import { Col } from "ComponentsUI/Styles/Grid";
import { EmptyStub } from "ComponentsUI/EmptyStub";
import Button from "ComponentsUI/Button";

const useStyles = createUseStyles((theme) => ({
	header: {
		fontSize: "48px",
		color: "#5812fe",
	},
	buttonSpan: {
		fontSize: "24px",
		color: "#d3cee1",
	},
}));

const EmptyStubWrapper = ({
	link,
	hideButton,
	headerText,
	displayText,
	buttonText,
	iconHeader,
	iconButton,
	buttonComponent,
}) => {
	const classes = useStyles();
	const match = useWithDefaultParams();
	let regionUrl = match?.params?.regionUrl;
	const mainUrl = generateUrl(configRouters.Default.route, {
		regionUrl: regionUrl,
	});

	return (
		<Container>
			<Row>
				<Col
					lg={{ size: 4, offset: 4 }}
					md={{ size: 4, offset: 4 }}
					sm={{ size: 4, offset: 4 }}
					xs={{ size: 6, offset: 3 }}
				>
					<EmptyStub
						header={headerText}
						text={displayText}
						icon={<span className={classNames("icon48", iconHeader, classes.header)} />}
						hideButton={hideButton}
						button={
							!!buttonComponent ? (
								buttonComponent
							) : (
								<Button
									component={<Link to={link ? link : mainUrl} />}
									typeText={"small"}
									size={"low"}
									status={"purple"}
								>
									{!!iconButton && (
										<span className={classNames("icon48", iconButton, classes.buttonSpan)} />
									)}
									{buttonText}
								</Button>
							)
						}
					/>
				</Col>
			</Row>
		</Container>
	);
};

export default withRouter(EmptyStubWrapper);
